import { Autocomplete, SelectSize, IconClose } from '@ui/src';
import InfoRow from '../../common/info-row';
import useCountriesOfInterests from '../hooks/use-countries-of-interests';
import { CountriesOfInterestTypes } from './types';

import cn from '../styles.module.css';
import commonStyles from '../../common/styles.module.css';

const CountriesOnInterests = ({
  value,
  setValue,
  setValuesList,
  index,
  values,
  list,
  disabled,
  title,
  error,
  clearErrors,
}: CountriesOfInterestTypes) => {
  const { onChange, deleteCountryOfInterest, errorVisible } =
    useCountriesOfInterests({
      values,
      index,
      setValue,
      setValuesList,
    });

  return (
    <InfoRow title={title} id="countriesOfInterestIds" borderless lessPadding>
      <>
        <div className={cn.sicCodeRow}>
          <Autocomplete
            name={`countriesOfInterestIds-${index}`}
            placeholder="Select values"
            value={value.id}
            onChange={(e) => {
              onChange(e);
              clearErrors('countriesOfInterestIds');
            }}
            className={`${commonStyles.newApplicationAutocomplete} ${
              disabled ? commonStyles.newApplicationAutocompleteDisabled : ''
            }`}
            size={SelectSize.SMALL}
            list={list}
            disabled={disabled}
            tabIndex={disabled ? -1 : 0}
            error={error}
            fullWidth
            borderless
          />
          {!disabled && (
            <button
              type="button"
              className={cn.deleteSicCodeButton}
              onClick={() => deleteCountryOfInterest(value.id)}
              aria-label="Delete button"
              tabIndex={-1}
            >
              <IconClose width={15} height={15} />
            </button>
          )}
        </div>
        {errorVisible && (
          <div className={cn.sicCodesError}>
            Countries of interest must be unique
          </div>
        )}
      </>
    </InfoRow>
  );
};

export default CountriesOnInterests;
